import React, { useContext, useEffect } from 'react';
import cookies from 'js-cookie';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import AppRoutes from './Routes/AppRoutes';
import useSocketAPI from './hooks/network/useSocketAPI';
import { AppContext } from './context/AppContext';

function App() {
  const { loadApp } = useContext(AppContext);

  if (cookies.get('authToken') || cookies.get('.AspNetCore.Cookies')) {
    useSocketAPI();
  }

  useEffect(() => {
    if (cookies.get('authToken') || cookies.get('.AspNetCore.Cookies')) {
      loadApp?.();
    }
  }, []);

  return (
    <div className='App'>
      <ToastContainer />
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </div>
  );
}

export default App;
